// Formatting for the Daily Productivity Report. Tons and hours to two places
// below 100 and whole above it: 0.89 tons is a real ticket, and 132,925.04
// tons for a quarter carries no meaning past the decimal point.

export const fmtNumber = (n) => (n === null || n === undefined ? '—' : Number(n).toLocaleString('en-US'));

export function fmtTons(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  const digits = Math.abs(n) < 100 ? 2 : 0;
  return Number(n).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function fmtPct(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return `${Number(n).toFixed(1)}%`;
}

export function fmtRate(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return Number(n).toFixed(2);
}

// Days are 'YYYY-MM-DD' strings from the API and are never turned into a
// Date in the browser's zone: new Date('2026-09-14') is UTC midnight, which
// in Pacific is the evening of the 13th.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export function fmtDay(d, { weekday = false, short = false } = {}) {
  if (!d) return '—';
  const [y, m, day] = d.split('-').map(Number);
  const wd = WEEKDAYS[new Date(Date.UTC(y, m - 1, day)).getUTCDay()];
  if (short) return `${m}/${day}`;
  return `${weekday ? `${wd} ` : ''}${MONTHS[m - 1]} ${day}, ${y}`;
}

// Calendar arithmetic on 'YYYY-MM-DD', in UTC so no zone can shift a day.
export function addDays(d, n) {
  const [y, m, day] = d.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, day + n)).toISOString().slice(0, 10);
}
export const monthStart = (d) => `${d.slice(0, 8)}01`;

// The report's tons and hours: always two places, as the Tableau report
// shows them, so a column reads straight down.
export function fmtTons2(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
